import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BatchSignComponent } from './views/batch-sign/batch-sign.component';

const routes: Routes = [
  {
    path: '',
    component: BatchSignComponent,
  },
  {
    path: ':id',
    loadChildren: () => import('../details-document-simplificado/details-document-simplificado.module').then(m => m.DetailsDocumentSimplificadoModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BatchSignRoutingModule {}
